jQuery(($) => {
  $(document).on('click', '.dealer-parent-category', function (e) {
    e.preventDefault();
    $(this).toggleClass('open');
    $(this)
      .siblings('.children')
      .slideToggle();
    // mm_maps.map.map.setCenter({lat:0, lng:0})
  });
  $('.maksimer-map-search-form').submit((e) => {
    e.preventDefault();
    $('body').animate({ scrollTop: 0 }, 700);
  });

  $(document).on('click', '.map-location-link', function (e) {
    e.preventDefault();
    const lat = $(this).data('lat');
    const lng = $(this).data('lng');

    $('body').animate({ scrollTop: 0 }, 500);
    mm_maps.map.map.setCenter({ lat, lng });
    mm_maps.map.map.setZoom(15);
  });
});
